<i18n>
{
    "ru": {
        "is_representative": "Вы представитель?",
        "shop": "Магазин",
        "rate_shop": "Оценить магазин",
        "description_title": "Описание",
        "official_site": "Официальный сайт",
        "manage_shop": "Управление магазином",
        "shop_information": "Информация о магазине",
        "phone": "Телефон",
        "email": "Электронный адрес",
        "shop_type": "Тип магазина",
        "assortment": "Ассортимент",
        "work_time": "Время работы",
        "delivery": "Доставка",
        "free_shipping": "Есть бесплатная доставка",
        "delivery_method": "Способы доставки",
        "payment": "Оплата",
        "we_in_socialweb": "Мы в социальных сетях",
        "buyers_opinions": "Мнение покупателей",
        "show_my_opinion": "Показывать моё мнение",
        "show_community_opinion": "Показывать мнение сообщества",
        "my_opinion": "Мое мнение",
        "rate": "Оценить",
        "title_reviews_comments": "Отзывы и комментарии",
        "read_also": "Читайте также",
        "best_articles": "Лучшие статьи",
        "interesting_collections": "Интересные подборки",
        "change_rate": "Изменить оценку",
        "shop_liked": "Магазин добавлен в избранное",
        "shop_unliked": "Магазин удален из избранного",
        "shop_already": "Магазин уже в избранном",
        "shop_scores_only_one": "балл",
        "shop_scores_only_two": "балла",
        "shop_scores_only_three": "баллов",
        "shop_scores_only_start": "Вы оценили магазин на",
        "shop_scores_only_end": "Хотите написать отзыв?",
        "shop_scores_with_comment": "Вы уже оценивали этот магазин. <br/>Хотите оценить ещё раз?",
        "thank_you_for_your_contribute": "Спасибо за ваш вклад в развитие энциклопедии!",
        "tooltip_like": "Сохранить в избранное",
        "tooltip_like_users": "<br><span class=\"tooltip__note\">Понравилось {total}</span>",
        "tooltip_subscribe": "Подписаться на обновления",
        "tooltip_share": "Поделиться",
        "success": {
            "title": "Спасибо!",
            "text": "Мы рассмотрим вашу заявку на подтверждение представительства магазина в ближайшее время. По результату вы получите уведомление.",
            "button": "Понятно"
        }
    }
}
</i18n>

<template>
    <div class="shop-detail-page">

        <PageBlock
            :content-visible="isDeviceDesktop"
            class="shop-detail-page__main-wrapper">
            <Breadcrumb show-prev-button
                prev-path-name="Shops"
                :items="breadcrumbs"/>

            <SectionCard v-if="isDeviceDesktop"
                sidebar="detail"
                class="shop-detail-page__header">

                <template #leftbar>
                    <picture class="shop-detail-page__single-picture shop-detail-page__gallery">
                        <img v-lazy-load :data-src="get(shop, 'logo.url', getNoImage)" 
                            :alt="get(shop, 'logo.alt', '')" 
                            data-not-lazy />
                    </picture>

                    <PageBlock content-padding
                        v-if="manageShopIsAvailable"
                        small-title
                        class="shop-detail-page__desktop-manage-shop"
                        :title="$t('manage_shop')">

                        <InfoTableRow>
                            <div
                                class="shop-detail-page__link"
                                @click="onAddShopClick"
                                slot="title">
                                {{ $t('shop_information') }}
                            </div>
                        </InfoTableRow>
                        <InfoTableRow class="shop-detail-page__remote-table-row">
                            <nuxt-link
                                slot="title"
                                class="shop-detail-page__link"
                                :to="{name: 'shopsDetailComments', params: {code: shop.code}}">
                                {{ $t('title_reviews_comments') }}
                                <!-- <span class="shop-detail-page__link-caption" slot="entry">
                                    +7
                                </span> -->
                            </nuxt-link>
                        </InfoTableRow>
                    </PageBlock>

                    <PageBlock class="shop-detail-page__left-content-block"
                        :title="$t('description_title')"
                        small-title>
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <app-content v-if="descVisible"
                            class="html-content html-content_sidebar"
                            :html="get(shop, 'description')"/>
                    </PageBlock>

                    <PageBlock :smallTitle="isDeviceDesktop"
                        class="shop-detail-page__left-content-block_news"
                        v-if="relatedNews && relatedNews.length"
                        :title="$t('read_also')">
                        <ArticlesList
                            :no-margin-top="isDeviceDesktop"
                            :articles="relatedNews"
                            :date-order="false" />
                    </PageBlock>

                    <PageBlock :smallTitle="isDeviceDesktop"
                        v-if="relatedArticles && relatedArticles.length"
                        :title="$t('best_articles')">

                        <div class="shop-detail-page-block">
                            <ArticleRowItem
                                :key="index + article.code"
                                v-for="(article, index) in relatedArticles"
                                :data="article"/>
                        </div>

                    </PageBlock>
                    <PageBlock :smallTitle="isDeviceDesktop"
                        v-if="relatedPages && relatedPages.length"
                        :title="$t('interesting_collections')">

                        <div class="perfume__page-block">
                            <LinkedPagesList :items="relatedPages"/>
                        </div>

                    </PageBlock>

                </template>

                <template #rightbar>

                    <template v-if="!isCommentsPage">

                        <div class="shop-detail-page__desktop-buttons">
                            <ButtonSquare
                                :icon="heartIcon(shopLiked, true)"
                                class="shop-detail-page__button-like rightbar__button"
                                v-tooltip.top="{
                                    content: likesCountTooltipPhrase, 
                                    offset: 14, 
                                    classes: 'tooltip_center'
                                }"
                                :aria-label="likesCountTooltipPhrase"
                                @click.native="likeShop"/>

                            <ButtonSquare
                                class="rightbar__button"
                                :class="{'btn__subscribed_active': userSubscribed}"
                                :icon="subscribeIcon(userSubscribed)"
                                v-tooltip.top="{content: $t('tooltip_subscribe'), offset: 14}"
                                :aria-label="$t('tooltip_subscribe')"
                                @click.native="handleSubscribe"/>

                            <ButtonSquare
                                class="rightbar__button"
                                icon="icon-share"
                                v-tooltip.top="{content: $t('tooltip_share'), offset: 14}"
                                :aria-label="$t('tooltip_share')"
                                @click.native="sharePage(shop)"/>

                            <div v-if="!manageShopIsAvailable"
                                v-click-outside="hideMenuMore"
                                class="button-wrapper rightbar__button">
                                <ButtonSquare
                                    @click.native="isDeviceDesktop ? triggerMenuMore() : openRateActions()"
                                    icon="icon-more" />
                                <MenuActions
                                    class="shop-detail-page__menu-more"
                                    :data-visible="showMenuMore"
                                    :items="itemsShowMore" />
                            </div>
                        </div>

                        <div class="perfume-page__title">
                            <h1 class="shop-detail-page__title-name">
                                <span v-if="isDeviceDesktop" class="shop-detail-page__title-caption">{{ $t('shop') }}</span>
                                {{ get(shop, 'name', '') }}
                            </h1>
                        </div>

                        <div class="shop-detail-page__header-reviews">
                            <div class="shop-detail-page__review-button-wrapper">
                                <ButtonBase icon="stats" @click.native="onReviewClick">
                                    {{ $t('rate_shop') }}
                                </ButtonBase>

                                <!-- eslint-disable-next-line -->
                                <p v-html="reviewButtonSubtext"
                                    v-if="reviewButtonSubtext"
                                    class="shop-detail-page__review-button-subtext"></p>
                            </div>
                            <RatingAndReviews
                                v-if="shop.ratings || isDeviceDesktop"
                                class="shop-detail-page__rating-and-reviews"
                                :rating="get(shop, 'ratings.value', 0)"
                                :reviews="ratingTotal"
                                :comments="get(shop, 'comments.totalFirstLevel', 0)"
                                @on-scroll-to-comments="scrollToComments"/>
                        </div>

                        <PageBlock
                            :smallTitle="isDeviceDesktop"
                            v-if="showManageShopBlock"
                            class="shop-detail-page__manage-shop"
                            description-padding
                            :title="$t('manage_shop')">
                            <div slot="title-button" class="shop-detail-page__manage-shop-counter">+17</div>
                        </PageBlock>
                        <PageBlock
                            :smallTitle="isDeviceDesktop"
                            id="facts_table"
                            class="shop-detail-page__info-table">

                            <InfoTableRow v-if="siteName">
                                <span slot="title">{{ $t('official_site') }}</span>
                                <a slot="entry"
                                    target="_blank"
                                    rel="nofollow"
                                    :href="siteUrl">
                                    {{ siteName }}
                                </a>
                            </InfoTableRow>

                            <InfoTableRow v-if="get(shop, 'phone', null)">
                                <span slot="title">{{ $t('phone') }}</span>
                                <a slot="entry"
                                    rel="nofollow"
                                    :href="'tel:' + get(shop, 'phone', null)">
                                    {{ get(shop, 'phone', null) }}
                                </a>
                            </InfoTableRow>

                            <InfoTableRow v-if="get(shop, 'email', null)">
                                <span slot="title">{{ $t('email') }}</span>
                                <a slot="entry"
                                    rel="nofollow"
                                    :href="'mailto:' + get(shop, 'email', null)">
                                    {{ get(shop, 'email', null) }}
                                </a>
                            </InfoTableRow>

                            <InfoTableRow entry-to-bottom v-if="get(shop, 'shopTypes', null)">
                                <span slot="title"> {{ $t('shop_type') }} </span>
                                <div slot="entry">
                                    <template v-for="(itemType, index) in shop.shopTypes">
                                        {{ getPropertyNameFormatted(itemType, index, shop.shopTypes) }}
                                    </template>
                                </div>
                            </InfoTableRow>

                            <InfoTableRow v-if="get(shop, 'perfumery', null)"
                                entry-to-bottom
                                content-no-margin
                                content-small>
                                <span slot="title">{{ $t('assortment') }}</span>
                                <div slot="entry">
                                    <template v-for="(perfumeryType, index) in shop.perfumery">
                                        {{ getPropertyNameFormatted(perfumeryType, index, shop.perfumery) }}
                                    </template>
                                </div>
                                <div v-if="get(shop, 'perfumeryNote')" slot="content">
                                    {{ shop.perfumeryNote }}
                                </div>
                            </InfoTableRow>

                            <InfoTableRow entry-to-bottom v-if="get(shop, 'workSchedule', null)">
                                <span slot="title"> {{ $t('work_time') }} </span>
                                <span slot="content"> {{ get(shop, 'workSchedule', null) }} </span>
                            </InfoTableRow>

                            <InfoTableRow entry-to-bottom
                                content-no-margin
                                content-small
                                v-if="getDeliveryDirections.length || shop.deliveryNote">
                                <span slot="title"> {{ $t('delivery') }} </span>
                                <span slot="entry" v-if="getDeliveryDirections.length">
                                    <template v-for="(region, index) in getDeliveryDirections">
                                        {{ getPropertyNameFormatted(region, index, getDeliveryDirections) }}
                                    </template>
                                </span>
                                <span slot="entry" v-else-if="shop.deliveryType">
                                    <template v-for="(type, index) in shop.deliveryType">
                                        {{ getPropertyNameFormatted(type, index, shop.deliveryType) }}
                                    </template>
                                </span>
                                <div slot="content" v-if="shop.deliveryNote">
                                    <span class="info-table-row__content-row">
                                        {{ get(shop, 'deliveryNote', null) }}
                                    </span>
                                </div>
                            </InfoTableRow>

                            <InfoTableRow entry-to-bottom
                                content-no-margin
                                content-small
                                v-if="get(shop, 'deliveryMethods', null) || get(shop, 'deliveryMethodsNote') || get(shop, 'freeDeliveryNote')">
                                <span slot="title"> {{ $t('delivery_method') }} </span>
                                <div slot="entry" v-if="get(shop, 'deliveryMethods')">
                                    <template v-for="(region, index) in get(shop, 'deliveryMethods', null)">
                                        {{ getPropertyNameFormatted(region, index, shop.deliveryMethods) }}
                                    </template>
                                </div>
                                <div slot="content">
                                    <span class="info-table-row__content-row" v-if="get(shop, 'deliveryMethodsNote')">
                                        {{ get(shop, 'deliveryMethodsNote') }}
                                    </span>

                                    <span
                                        class="dotted-link"
                                        v-if="isFreeShipping && get(shop, 'freeDeliveryNote', null)"
                                        @click.prevent="openInfoPopup(get(shop, 'freeDeliveryNote', null))">
                                        {{ $t('free_shipping') }}
                                    </span>

                                    <span v-else-if="isFreeShipping">
                                        {{ $t('free_shipping') }}
                                    </span>
                                </div>
                            </InfoTableRow>

                            <InfoTableRow entry-to-bottom
                                content-no-margin
                                content-small
                                v-if="get(shop, 'paymentMethods', null)">
                                <span slot="title"> {{ $t('payment') }} </span>
                                <div slot="entry">
                                    <template v-for="(region, index) in get(shop, 'paymentMethods', null)">
                                        {{ getPropertyNameFormatted(region, index, shop.paymentMethods) }}
                                    </template>
                                </div>
                                <span slot="content" v-if="get(shop, 'paymentMethodsNote')">
                                    <span class="info-table-row__content-row">
                                        {{ get(shop, 'paymentMethodsNote') }}
                                    </span>
                                </span>
                            </InfoTableRow>

                            <InfoTableRow entry-to-bottom
                                v-if="get(shop, 'socials', null)"
                                content-no-margin>
                                <span slot="title"> {{ $t('we_in_socialweb') }} </span>
                                <div class="shop-detail-page__social-block" slot="content">
                                    <ButtonSocial v-for="item in shop.socials"
                                        :key="item.code"
                                        :full-url="item.htmlUrl"
                                        :name="item.code"
                                        theme="light"
                                        :rounded="false"
                                        class="shop-detail-page__social-button"/>
                                </div>
                            </InfoTableRow>
                        </PageBlock>

                        <PageBlock
                            bigTitle
                            content-padding
                            :title="computedOpinionTitle">

                            <template #title-button>
                                
                                <div v-if="isExistUserOpinion"
                                    class="shop-detail-page__opinion-btn" 
                                    @mouseover="showRateMenu = true"
                                    @mouseleave="showRateMenu = false">

                                    <ButtonBase
                                        dots-mode
                                        icon="icon-more"
                                        :show-as-link="true"
                                        class="button__block-more"/>

                                    <PopupActions
                                        v-if="showRateMenu"
                                        class="shop-detail-page__menu-rate"
                                        is-tooltip
                                        v-bind="itemsChangeRate" />
                                </div>

                                <ButtonBase
                                    v-else
                                    @click.native="openPopupRate"
                                    icon="edit-velvet"
                                    :show-as-link="true">
                                    {{ $t('rate') }}
                                </ButtonBase>
                                
                            </template>

                            <BlockUsersOpinion
                                class="shop-detail-page__list-opinion"
                                disable-sliders
                                :block-key-prefix="opinionType"
                                v-bind="opinionValues" />

                        </PageBlock>
                        <PageBlock
                            big-title
                            id="comments"
                            :title="$t('title_reviews_comments')"
                            :counter="get(shop, 'comments.totalFirstLevel', 0)"
                            class="shop-detail-page__comments-block">
                            <LazyHydrate when-visible :trigger-hydration="isHydrate">
                                <CommentsAndReviews
                                    ref="comments"
                                    type="reviews"
                                    :entity-source-url="'/shops/' + shop.code"
                                    :start-total-count="300"
                                    :start-sort="{'by': 'popular', 'dir': 'desc'}"
                                    class="shop-detail-page__comments-and-reviews"
                                    id="shop_comments"
                                    hide-shelf-buttons
                                    page="shop"
                                    show-rating-and-votes
                                    :comments-total="commentsTotal"
                                    :as-gift="asGift"
                                    :ratings="get(shop, 'ratings', {})"
                                    :comments="commentsList"
                                    :perfume-liked="shopLiked"
                                    @reviewClick="onReviewClick">

                                    <div class="shop-detail-page__reviews-button-wrapper"
                                        v-if="isDeviceDesktop"
                                        slot="right-wrapper">

                                        <ButtonBase icon="stats" @click.native="onReviewClick">
                                            {{ $t('rate_shop') }}
                                        </ButtonBase>

                                        <!-- eslint-disable-next-line -->
                                        <p v-html="reviewButtonSubtext"
                                            v-if="reviewButtonSubtext"
                                            class="shop-detail-page__review-button-subtext"></p>

                                    </div>

                                </CommentsAndReviews>
                            </LazyHydrate>

                        </PageBlock>
                    </template>

                    <template v-else>
                        <PageBlock
                            big-title
                            id="comments"
                            class="shop-detail-page__feed"
                            :title="$t('title_reviews_comments')"
                            :counter="get(shop, 'comments.totalFirstLevel', 0)">

                            <FeedList
                                openReplies
                                v-if="commentsList.items"
                                @items-loaded="itemsLoaded"
                                :list="commentsList" />

                            <BlockEmptyPosts v-else data-type="shop"/>

                        </PageBlock>
                    </template>

                </template>
            </SectionCard>

            <template v-else>
                <SectionCard v-if="!isCommentsPage"
                    class="shop-detail-page__header"
                    :loaded="loaded">

                    <template #leftbar v-if="isDeviceDesktop">
                    </template>

                    <div class="shop-detail-page__rightbar"
                        slot="rightbar">
                        <ButtonSquare
                            :icon="heartIcon(shopLiked, true)"
                            class="shop-detail-page__button-like rightbar__button"
                            aria-label="like"
                            @click.native="likeShop"/>

                        <ButtonSquare
                            class="rightbar__button"
                            :class="{'btn__subscribed_active': userSubscribed}"
                            :icon="subscribeIcon(userSubscribed)"
                            aria-label="subscribe"
                            @click.native="handleSubscribe"/>

                        <ButtonSquare
                            class="rightbar__button"
                            icon="icon-share"
                            aria-label="share"
                            @click.native="sharePage(shop)"/>

                        <ButtonSquare
                            v-if="!manageShopIsAvailable"
                            class="rightbar__button"
                            icon="icon-more"
                            @click.native="onMoreClick"/>
                    </div>

                    <template #main>
                        <picture class="shop-detail-page__single-picture shop-detail-page__gallery">
                            <img v-lazy-load :data-src="get(shop, 'logo.url', getNoImage)" 
                                :alt="get(shop, 'logo.alt', '')" 
                                data-not-lazy/>
                        </picture>
                    </template>

                    <div class="shop-detail-page__title"
                        slot="header">
                        <h1 class="shop-detail-page__title-name">{{ get(shop, 'name', '') }}</h1>
                        <!-- eslint-disable-next-line vue/no-v-html -->
                        <app-content class="shop-detail-page__title-type html-content html-content_sidebar" :html="get(shop, 'description')" />
                    </div>

                    <template #content>
                        <RatingAndReviews
                            v-if="shop.ratings"
                            class="shop-detail-page__rating-and-reviews"
                            :rating="get(shop, 'ratings.value', 0)"
                            :reviews="ratingTotal"
                            :comments="get(shop, 'comments.totalFirstLevel', 0)"
                            @on-scroll-to-comments="scrollToComments"/>
                    </template>

                    <template #footer>
                        <ButtonBase icon="stats"
                            @click.native="onReviewClick">{{ $t('rate_shop') }}
                        </ButtonBase>

                        <!-- eslint-disable-next-line -->
                        <p v-html="reviewButtonSubtext"
                            v-if="reviewButtonSubtext"
                            class="shop-detail-page__review-button-subtext"></p>
                    </template>

                </SectionCard>

                <PageBlock
                    v-else
                    big-title
                    id="comments"
                    class="shop-detail-page__feed"
                    :title="$t('title_reviews_comments')"
                    :counter="get(shop, 'comments.totalFirstLevel', 0)">

                    <FeedList
                        openReplies
                        v-if="commentsList.items"
                        @items-loaded="itemsLoaded"
                        :list="commentsList" />

                    <BlockEmptyPosts v-else data-type="review"/>

                </PageBlock>
            </template>
        </PageBlock>

        <template v-if="!isCommentsPage">
            <PageBlock
                v-if="!isDeviceDesktop && manageShopIsAvailable"
                class="shop-detail-page__manage-shop"
                description-padding
                @click.native="onManageShopClick"
                :title="$t('manage_shop')">
                <!-- <div slot="title-button" class="shop-detail-page__manage-shop-counter">+17</div> -->
            </PageBlock>

            <PageBlock
                v-if="!isDeviceDesktop"
                content-padding
                id="facts_table"
                class="shop-detail-page__info-table">

                <InfoTableRow v-if="siteName">
                    <span slot="title">{{ $t('official_site') }}</span>
                    <a slot="entry"
                        target="_blank"
                        rel="nofollow"
                        :href="siteUrl">
                        {{ siteName }}
                    </a>
                </InfoTableRow>

                <InfoTableRow v-if="get(shop, 'phone', null)">
                    <span slot="title">{{ $t('phone') }}</span>
                    <a slot="entry"
                        rel="nofollow"
                        :href="'tel:' + get(shop, 'phone', null)">
                        {{ get(shop, 'phone', null) }}
                    </a>
                </InfoTableRow>

                <InfoTableRow v-if="get(shop, 'email', null)">
                    <span slot="title">{{ $t('email') }}</span>
                    <a slot="entry"
                        rel="nofollow"
                        :href="'mailto:' + get(shop, 'email', null)">
                        {{ get(shop, 'email', null) }}
                    </a>
                </InfoTableRow>

                <InfoTableRow
                    large-padding
                    entry-to-bottom
                    v-if="get(shop, 'shopTypes', null)">
                    <span slot="title"> {{ $t('shop_type') }} </span>
                    <div slot="entry">
                        <template v-for="(itemType, index) in shop.shopTypes">
                            {{ getPropertyNameFormatted(itemType, index, shop.shopTypes) }}
                        </template>
                    </div>
                </InfoTableRow>

                <InfoTableRow v-if="get(shop, 'perfumery', null)"
                    large-padding
                    entry-to-bottom
                    content-no-margin
                    content-small>
                    <span slot="title">{{ $t('assortment') }}</span>
                    <div slot="entry">
                        <template v-for="(perfumeryType, index) in shop.perfumery">
                            {{ getPropertyNameFormatted(perfumeryType, index, shop.perfumery) }}
                        </template>
                    </div>
                    <div v-if="get(shop, 'perfumeryNote')" slot="content">
                        {{ shop.perfumeryNote }}
                    </div>
                </InfoTableRow>

                <InfoTableRow
                    large-padding
                    entry-to-bottom
                    v-if="get(shop, 'workSchedule', null)">
                    <span slot="title"> {{ $t('work_time') }} </span>
                    <span slot="entry"> {{ get(shop, 'workSchedule', null) }} </span>
                </InfoTableRow>

                <InfoTableRow 
                    entry-to-bottom
                    large-padding
                    content-no-margin
                    content-small
                    v-if="getDeliveryDirections.length || shop.deliveryNote">
                    <span slot="title"> {{ $t('delivery') }} </span>
                    <span slot="entry" v-if="getDeliveryDirections.length">
                        <template v-for="(region, index) in getDeliveryDirections">
                            {{ getPropertyNameFormatted(region, index, getDeliveryDirections) }}
                        </template>
                    </span>
                    <span slot="entry" v-else-if="shop.deliveryType">
                        <template v-for="(type, index) in shop.deliveryType">
                            {{ getPropertyNameFormatted(type, index, shop.deliveryType) }}
                        </template>
                    </span>
                    <div slot="content" v-if="shop.deliveryNote">
                        <span class="info-table-row__content-row">
                            {{ get(shop, 'deliveryNote', null) }}
                        </span>
                    </div>
                </InfoTableRow>

                <InfoTableRow
                    entry-to-bottom
                    large-padding
                    content-no-margin
                    content-small
                    v-if="get(shop, 'deliveryMethods', null) || get(shop, 'deliveryMethodsNote') || get(shop, 'freeDeliveryNote')">
                    <span slot="title"> {{ $t('delivery_method') }} </span>
                    <div slot="entry" v-if="get(shop, 'deliveryMethods')">
                        <template v-for="(region, index) in get(shop, 'deliveryMethods', null)">
                            {{ getPropertyNameFormatted(region, index, shop.deliveryMethods) }}
                        </template>
                    </div>
                    <div slot="content">
                        <span class="info-table-row__content-row" v-if="get(shop, 'deliveryMethodsNote')">
                            {{ get(shop, 'deliveryMethodsNote') }}
                        </span>

                        <span
                            class="dotted-link"
                            v-if="isFreeShipping && get(shop, 'freeDeliveryNote', null)"
                            @click.prevent="openInfoPopup(get(shop, 'freeDeliveryNote', null))">
                            {{ $t('free_shipping') }}
                        </span>

                        <span v-else-if="isFreeShipping">
                            {{ $t('free_shipping') }}
                        </span>
                    </div>
                </InfoTableRow>

                <InfoTableRow
                    entry-to-bottom
                    large-padding
                    content-no-margin
                    content-small
                    v-if="get(shop, 'paymentMethods', null)">
                    <span slot="title"> {{ $t('payment') }} </span>
                    <div slot="entry">
                        <template v-for="(region, index) in get(shop, 'paymentMethods', null)">
                            {{ getPropertyNameFormatted(region, index, shop.paymentMethods) }}
                        </template>
                    </div>
                    <span slot="content" v-if="get(shop, 'paymentMethodsNote')">
                        <span class="info-table-row__content-row">
                            {{ get(shop, 'paymentMethodsNote') }}
                        </span>
                    </span>
                </InfoTableRow>

                <InfoTableRow
                    large-padding
                    entry-to-bottom
                    v-if="get(shop, 'socials', null)"
                    content-no-margin>
                    <span slot="title"> {{ $t('we_in_socialweb') }} </span>
                    <div class="shop-detail-page__social-block" slot="content">
                        <ButtonSocial v-for="item in shop.socials"
                            :key="item.code"
                            :full-url="item.htmlUrl"
                            :name="item.code"
                            theme="light"
                            :rounded="false"
                            class="shop-detail-page__social-button"/>
                    </div>
                </InfoTableRow>
            </PageBlock>

            <PageBlock
                v-if="!isDeviceDesktop"
                content-padding
                :title="computedOpinionTitle"
                class="shop-detail-page__opinion">

                <template #title-button>
                    <ButtonBase
                        v-if="isExistUserOpinion"
                        dots-mode
                        @click.native="openRateActions"
                        icon="icon-more"
                        :show-as-link="true"
                        class="button__block-more"/>
                    <ButtonBase
                        v-else
                        @click.native="openPopupRate"
                        icon="edit-velvet"
                        :show-as-link="true">
                        {{ $t('rate') }}
                    </ButtonBase>
                </template>

                <BlockUsersOpinion
                    class="shop-detail-page__list-opinion"
                    disable-sliders
                    :block-key-prefix="opinionType"
                    v-bind="opinionValues" />

            </PageBlock>

            <PageBlock
                v-if="!isDeviceDesktop"
                id="comments"
                :title="$t('title_reviews_comments')"
                :counter="get(shop, 'comments.totalFirstLevel', 0)">

                <LazyHydrate when-visible :trigger-hydration="isHydrate">
                    <CommentsAndReviews
                        hide-shelf-buttons
                        page="shop"
                        type="reviews"
                        :entity-source-url="'/shops/' + shop.code"
                        :start-total-count="300"
                        :start-sort="{'by': 'popular', 'dir': 'desc'}"
                        show-rating-and-votes
                        :comments-total="commentsTotal"
                        :as-gift="asGift"
                        :ratings="get(shop, 'ratings')"
                        :comments="commentsList"
                        :perfume-liked="shopLiked"
                        class="shop-detail-page__comments"
                        @reviewClick="onReviewClick"
                        @comments-count-updated="shop.comments = shop.comments || {}; shop.comments.totalFirstLevel = $event.firstLevel"/>
                </LazyHydrate>

            </PageBlock>

            <PageBlock v-if="!isDeviceDesktop &&  relatedNews && relatedNews.length" :title="$t('read_also')">
                <ArticlesList
                    :articles="relatedNews"
                    :date-order="false" />
            </PageBlock>

            <PageBlock v-if="!isDeviceDesktop && relatedArticles && relatedArticles.length"
                :title="$t('best_articles')">

                <div class="shop-detail-page-block">
                    <ArticleRowItem
                        :key="index + article.code"
                        v-for="(article, index) in relatedArticles"
                        :data="article"/>
                </div>
            </PageBlock>

            <PageBlock v-if="!isDeviceDesktop && relatedPages && relatedPages.length"
                :title="$t('interesting_collections')">

                <div class="perfume__page-block">
                    <LinkedPagesList :items="relatedPages"/>
                </div>
            </PageBlock>
        </template>

    </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

import { mapGetters } from "vuex";
import get from "lodash/get";
import filter from "lodash/filter";
import concat from "lodash/concat";
import snakeCase from "lodash/snakeCase";

import LazyHydrate from '@/modules/LazyHydrate';

import buttonActionsMixin from "@/mixins/catalog/buttonActions";
import SubscriptionsMixin from '@/mixins/catalog/subscriptions.mixins'

import PageBlock from "@/components/layout/AppPageBlock";
import Breadcrumb from "@/components/layout/nav/Breadcrumb";
import SectionCard from "@/components/layout/AppSectionCard";
import ButtonSquare from "@/components/ui/buttons/ButtonSquare";
import RatingAndReviews from "@/components/layout/blocks/RatingAndReviews";
import ButtonBase from "@/components/ui/buttons/ButtonBase";
import InfoTableRow from "@/components/layout/BaseInfoTableRow";
import ButtonSocial from "@/components/ui/buttons/ButtonSocial";
import BlockUsersOpinion from "@/components/catalog/BlockUsersOpinion";
import CommentsAndReviews from "@/components/perfume/CommentsAndReviews";
import ArticlesList from "@/components/layout/blocks/ArticlesList/ArticlesList";
import ArticleRowItem from "@/components/layout/blocks/ArticlesList/ArticleRowItem";
import LinkedPagesList from "@/components/layout/blocks/LinkedPagesList";
import AppContent from '@/components/layout/AppContent'
import PopupActions from '@/components/modal/perfume/CharacteristicsActions'
import MenuActions from "@/components/ui/MenuActions";
import BlockEmptyPosts from "@/components/profile/BlockEmptyPosts";

import Shop from "@/models/catalog/Shop";
import Property from "@/models/catalog/perfume/Property";
import Rating from "~/models/catalog/Rating";

import UserLikes from '@/mixins/userLikes.mixin';
import FeedList from '@/components/feed/FeedList';

export default {
    name: 'ShopsDetail',
    directives: { ClickOutside },
    components: {
        PopupActions,
        LinkedPagesList,
        ArticleRowItem,
        ArticlesList,
        CommentsAndReviews,
        BlockUsersOpinion,
        ButtonSocial,
        InfoTableRow, ButtonBase, RatingAndReviews, ButtonSquare, SectionCard, Breadcrumb, PageBlock,
        AppContent,
        LazyHydrate,
        MenuActions,
        FeedList,
        BlockEmptyPosts
    },
    mixins: [ buttonActionsMixin, SubscriptionsMixin, UserLikes ],
    fetchOnServer: false,
    fetch() {
        if (this.$auth.loggedIn) {
            if (this.$auth.user.id) {
                const userId = this.$auth.user.id

                const shop = new Shop({
                    code: this.$route.params.code
                })

                const authRequests = [
                    shop.userLikes().where('created_by', userId).get(),
                    shop.userRatings().where('created_by', userId).get(),
                    shop.properties().where('created_by', userId).get(),
                    shop.commentsRatings().where('created_by', userId).get(),
                    ...this.getSubscriptionsRequests()
                ]

                return Promise.all(authRequests).then(results => {
                    this.shopLiked = !!get(results, '[0][0].items[0]')
                    this.userRatings = get(results, '[1][0].items')
                    this.properties = get(results, '[2][0].items[0]', {})

                    const commentsRatings = get(results, '[3][0].items', [])

                    this.parseSubscriptions([ results[4], results[5] ])

                    this.$store.commit('setCommentsRatings', commentsRatings);
                    this.$bus.$emit('fetch-complete')
                });
            }
        }
    },
    async asyncData({app, query, params, error, route}) {
        const baseUrl = app.i18n.__baseUrl;
        const catalogHref = app.router.resolve({
            name: 'shops',
        }).href;
        const shopApi = new Shop;
        const shopModel = new Shop({ code: params.code });
        const ratingShop = new Rating().for(shopModel)

        const requests = [
            shopApi.find(params.code),
            route.name === 'shopsDetailComments' ?
                app.$api.get(`/users/accounts/shops/${params.code}/comments`, {params: {limit: 25}}) :
                shopModel.commentsList()
                    .params({sort: 'likes', order: 'desc'})
                    .where('per_page', 300)
                    .get(),
            shopModel.relatedNews().get(),
            shopModel.relatedPages().get(),
            shopModel.relatedArticles().get(),
            ratingShop.get()
        ];

        const userLoggedIn = app.$auth.userLoggedIn();

        if(userLoggedIn) requests.push(app.$api.get('/users/accounts/shops'));

        const result = await Promise.all(requests).then((results) => {
            const shop = get(results, '[0]', []);
            const commentsList = route.name === 'shopsDetailComments' ? get(results, '[1].data', {}) : get(results, '[1][0]', []);
            const relatedNews = get(results, '[2]', []);
            const relatedPages = get(results, '[3]', []);
            const relatedArticles = get(results, '[4]', []);
            const ratingShops = get(results, '[5][0].items', [])
            const manageData = get(results, '[6].data.items', []);

            // проверяем юзера на представительство
            const manageShopIsAvailable = manageData.some(item => item.code === shop.code);

            const breadcrumbs = [
                {
                    path: baseUrl,
                    name: app.i18n.t('breadcrumbs.perfumes'),
                },
                {
                    path: baseUrl + catalogHref,
                    name: app.i18n.t('breadcrumbs.shops'),
                },
                {
                    path: baseUrl + catalogHref + get(shop, 'code', ''),
                    name: get(shop, 'name', '')
                }
            ];

            if(route.name === 'shopsDetailComments'){
                breadcrumbs.push({
                    // path: '',
                    name: app.i18n.t('breadcrumbs.reviews_comments')
                });
            }

            return {
                shop,
                meta: shop.meta,
                commentsList,
                baseUrl,
                catalogHref,
                breadcrumbs,
                relatedArticles,
                relatedNews,
                relatedPages,
                ratingShops,
                manageShopIsAvailable
            }
        }).catch((e) => {
            error({statusCode: e.response.status, message: e.response.data});
        });

        if(!result.manageShopIsAvailable && route.name === 'shopsDetailComments')
            error({ statusCode: 404 });

        return result;
    },
    data() {
        return {
            shopRatings: {},
            ratingShops: [],
            loaded: false,
            manageShopIsAvailable: false,
            shopLiked: false,
            showManageShopBlock: false,
            showMenuMore: false,
            showRateMenu: false,
            breadcrumbs: [],
            userLikes: [],
            userRatings: [],
            commentsList: [],
            relatedNews: [],
            relatedArticles: [],
            relatedPages: [],
            shop: {},
            meta: {},
            properties: {},
            opinionType: 'community',
            eventName: 'change-opinion-type',
            itemsShowMore: [
                {
                    name: this.$t('is_representative'),
                    eventName: 'on-representative-request',
                    withAuth: true
                }
            ],
            isHydrate: false,
            isLikeProcess: false,
            feedLoaded: false,
            descVisible: true
        }
    },
    globalBus: {
        async 'like-shop'(value) {
            const notices = {
                'onLiked': this.$t("shop_liked"),
                'onUnliked': this.$t("shop_unliked"),
                'onLikeAlready': this.$t("shop_already"),
            };

            this.shopLiked = await this.onActionLike(value, new Shop({code: this.$route.params.code}), notices)
            this.isLikeProcess = false;
        },
        'auth-complete'() {
            this.$fetch();
            this.$nuxt.refresh();
        },
        'user-logout-after'(){
            if(this.isCommentsPage){
                this.$router.push({name: 'shopsDetail', params: {code: this.shop.code}});
            }else{
                this.$nuxt.refresh();
            }
        },
        'on-representative-request'() {
            this.showPopup('shop-representative', {shopCode: this.shop.code});
        },
        'open-popup-review'() {
            this.openPopupReview()
        },
        'open-popup-rate'() {
            this.showRateMenu = false

            this.showPopup('shop-rate', {
                userRate: this.properties,
                shop: {
                    name: get(this.shop, 'name', undefined),
                    logo: get(this.shop, 'logo', undefined)
                }
            },
            {
                width: this.isDeviceDesktop ? '600' : '100%',
                height: this.isDeviceDesktop ? '652' : '100%',
                fullscreen: !this.isDeviceDesktop,
                draggable: false
            })
        },
        'ratemore'() {
            this.openPopupRate()
        },
        'change-opinion-type'(value) {
            this.showRateMenu = false

            this.opinionType = value;
        },
        'shop-rate-update'(formData) {

            const shop = new Shop({
                code: this.$route.params.code
            })

            const property = new Property(this.formatOpinionsFromData(formData, true)).for(shop);

            this.properties = {
                ...this.properties,
                ...this.formatOpinionsFromData(formData)
            };

            property.save().then((response) => {
                
                const keys = Object.keys(this.opinionValues);
                for (const i in keys) {
                    if (response[keys[i]]) {
                        this.$set(this.shop, keys[i], response[keys[i]]);
                    }
                }
                this.$alert.info(this.$t('thank_you_for_your_contribute'));
            }).catch(e => {
                this.$alert.error(this.$t('alerts.error'));
            });

            this.closePopup();
        },
        'init-comments'(){
            this.isHydrate = true;
        },
        async 'popup-add-new-review'(review, isNew = false, stars, res) {
            const userId = this.$auth.user.id

            const shopModel = new Shop()
            const shop = new Shop({
                code: this.$route.params.code
            })

            if (isNew && this.shop) {
                if(!this.shop.ratings) {
                    const ratings = {
                        'total': 1,
                        'value': stars || 0
                    };
                    this.$set(this.shop, 'ratings', ratings);
                }
                else {
                    this.shop.ratings.total++;

                    if(stars && (parseInt(this.shop.ratings.value) === 0 || !this.shop.ratings.value)) {
                        this.shop.ratings.value = stars;
                    }
                }
            }
            this.$set(this.shop, 'comments.totalFirstLevel', get(this.shop, 'comments.totalFirstLevel', 0)+1);

            const ratings = await shop.userRatings().where('created_by', userId).get()

            this.shopRatings = await shopModel.find(this.$route.params.code)

            this.userRatings = get(ratings, '[0].items', [])
            this.shop.ratings = res;

            this.$alert.info(this.$t('thank_you_for_your_contribute'));

            if (this.isAllRate) {
                this.showPopup('rate-more', { page: 'shop', points: 2 })
            };

            if(review) this.$bus.$emit('add-new-review', review);
        },
        'open-add-shop-popup'(){
            this.showPopup('add-shop', {shop: this.shop});
        },
        'open-edit-shop-popup'(){
            this.showPopup('actions', {
                title: this.$t('manage_shop'),
                modalItems: [
                    {
                        name: this.$t('shop_information'),
                        eventName: 'open-add-shop-popup'
                    },
                    {
                        name: this.$t('title_reviews_comments'),
                        linkUrl: this.$router.resolve({
                            name: 'shopsDetailComments',
                            params: {
                                code: this.shop.code
                            }
                        }).href
                    }
                ]
            });
        },
        async 'on-shop-update'(){
            this.descVisible = false
            await this.$nuxt.refresh();
            this.descVisible = true;
        }
    },
    computed: {
        ...mapGetters(['getNoImage', 'isDeviceDesktop']),
        entityModel() {
            return new Shop({
                shop_code: this.entityCode
            })
        },
        entityCode() {
            return this.shop.code
        },
        entityTag() {
            return this.shop.entityTag
        },
        isAllRate() {
            return get(this.userRatings, '[0].stars', false) && !(this.properties);
        },
        computedOpinionTitle() {
            if(this.opinionType === 'my') {
                return this.$t('my_opinion');
            }
            return this.$t('buyers_opinions');
        },
        isExistUserRate() {
            return (this.userRatings && this.userRatings.length > 0);
        },
        isExistUserOpinion() {
            return this.properties && Object.values(this.properties).length;
        },
        isOpinionRate() {
            // TODO
            return this.properties.assortment && this.properties.delivery && this.properties.goodsQuality && this.properties.goodsReturns && this.properties.samples && this.properties.service
        },
        scoresDeclension() {
            return [
                this.$t('shop_scores_only_one'),
                this.$t('shop_scores_only_two'),
                this.$t('shop_scores_only_three'),
            ];
        },
        getDeliveryDirections() {
            return concat(get(this.shop, 'deliveryRegions', []), get(this.shop, 'deliveryCountries', []));
        },
        opinionValues() {
            if (this.opinionType === 'my') {
                return {
                    assortment: this.opinionCodeAdapter(get(this.properties, 'assortment', {})),
                    service: this.opinionCodeAdapter(get(this.properties, 'service', {})),
                    goodsQuality: this.opinionCodeAdapter(get(this.properties, 'goodsQuality', {})),
                    delivery: this.opinionCodeAdapter(get(this.properties, 'delivery', {})),
                    samples: this.opinionCodeAdapter(get(this.properties, 'samples', {})),
                    goodsReturns: this.opinionCodeAdapter(get(this.properties, 'goodsReturns', {}))
                }
            }

            return {
                assortment: get(this.shop, 'assortment', {}),
                service: get(this.shop, 'service', {}),
                goodsQuality: get(this.shop, 'goodsQuality', {}),
                delivery: get(this.shop, 'delivery', {}),
                samples: get(this.shop, 'samples', {}),
                goodsReturns: get(this.shop, 'goodsReturns', {})
            }
        },
        itemsChangeRate() {
            return {
                opinionType: this.opinionType,
                eventName: this.eventName,
                block: 'all'
            }
        },
        commentsTotal() {
            return get(this.shop, 'comments.total', 0)
        },
        ratingTotal() {
            return get(this.shop, 'ratings.total', 0)
        },
        asGift() {
            return !!get(this.shop, 'recommendationsAsGift', false);
        },
        isFreeShipping() {
            return get(this.shop, 'freeDelivery', false)
        },
        reviewButtonSubtext() {
            if (this.isExistUserRate) {
                const ratingOnlyStars = filter(this.userRatings, r => !r.comment)[0];
                if (ratingOnlyStars) {
                    const scoresStr = this.$options.filters.numberDeclension(ratingOnlyStars.stars, this.scoresDeclension);
                    return `${this.$t('shop_scores_only_start')} ${scoresStr}.<br/>${this.$t('shop_scores_only_end')}`;
                } else {
                    return this.$t('shop_scores_with_comment');
                }
            } else {
                return false;
            }
        },
        likesCountTooltipPhrase() {
            const likes = this.get(this.shop, 'likes.total', 0);

            if (likes < 1) {
                return this.$t('tooltip_like');
            }

            return this.$t('tooltip_like') + this.$t('tooltip_like_users', {
                total: this.$options.filters.numberDeclension(likes, this.$t('declensions.for_users'))
            });
        },
        siteUrl() {
            return get(this.shop, 'site.htmlUrl', null)
        },
        siteName() {
            if(get(this.shop, 'site.name'))
                return this.shop.site.name.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split('/')[0]
            return false;
        },
        isCommentsPage(){
            return this.$route.name === 'shopsDetailComments';
        }
    },
    async mounted() {
        this.loaded = true

        // eslint-disable-next-line
        if (process.client) {
            this.$bus.$on(this.eventName, value => {
                this.opinionType = value
            });
        }

        if (this.$route.hash) {
            this.isHydrate = true;

            if (this.$route.hash.includes('#comment_')) {
                this.scrollToComment(this.$route.hash.replace('#comment_',''));
            }
        }

        if(get(this.$route, 'params.request_id') && get(this.$route, 'params.confirm_code')){
            try{
                await this.$api.post('/shops/ownership-request-confirmation', {
                    id: this.$route.params.request_id,
                    code: this.$route.params.confirm_code
                });
                this.showPopup('success-popup', {
                    title: this.$t('success.title'),
                    text: this.$t('success.text'),
                    button: this.$t('success.button')
                });
            }catch(error){
                this.$alert.error(get(error, 'response.data.message', this.$t('alerts.error')));
            }
        }

        if(this.isCommentsPage){
            this.$store.commit('setEntityData', {
                name: this.shop.name,
                url: this.shop.htmlUrl,
                logo: this.shop.logo
            });
        }
    },
    methods: {
        get,
        formatOpinionsFromData(formData, transformToSnake = false) {
            const convertedData = [];
            Object.keys(formData).forEach(property => {
                if(property && formData[property].code) {
                    const newPropertyName = transformToSnake ? snakeCase(property) : property;
                    convertedData[newPropertyName] = formData[property].code
                }
            });

            return convertedData;
        },
        scrollToComment(comment) {
            if (!this.$refs.comments) {
                this.isHydrate = true;
            }
            this.$nextTick(() => {
                this.$refs.comments.scrollToComment(comment);
            });
        },
        /**
         * @return {{code: *}}
         */
        opinionCodeAdapter(property) {
            if(typeof property === 'string') {
                return {
                    code: property
                }
            }
        },
        getPropertyNameFormatted(propertyObject, index, array) {
            return get(propertyObject, 'name', '') + this.computedCommaString(index, array)
        },
        computedCommaString(currentIndex, array) {
            if(Array.isArray(array)) {
                return currentIndex + 1 < array.length ? ',' : ''
            }
            return false
        },
        hideRateMenu() {
            this.showRateMenu = false;
        },
        hideMenuMore() {
            this.showMenuMore = false;
        },
        triggerMenuMore() {
            this.showMenuMore = !this.showMenuMore;
        },
        openRateActions() {
            this.showPopup('characteristics-actions', {
                opinionType: this.opinionType,
                eventName: 'change-opinion-type'
            });
        },
        openPopupRate() {
            this.$authEmit('open-popup-rate')
        },
        onReviewClick() {
            this.$authEmit('open-popup-review');
        },
        likeShop() {
            if(!this.isLikeProcess){
                this.isLikeProcess = true;
                this.$authEmit('like-shop', !this.shopLiked);
            }
        },
        handleSubscribe() {
            this.$authEmit('subscribe', {
                type: 'shop',
                entity: {
                    name: this.shop.name,
                    code: this.entityCode,
                    picture: get(this.shop, 'logo.url')
                },
                entityTag: this.entityTag,
            })
        },
        onMoreClick() {
            this.showPopup('actions', {
                modalItems: this.itemsShowMore
            });
        },
        openInfoPopup(content) {
            this.showPopup('tooltip', {
                content
            });
        },
        openPopupReview() {
            this.showPopup('popup-review', {ratings: this.userRatings, page: 'shop'});
        },
        scrollToComments() {
            this.isHydrate = true
            this.$scrollTo('#comments', 750);
        },
        onAddShopClick(){
            this.$authEmit('open-add-shop-popup');
        },
        onManageShopClick(){
            this.$authEmit('open-edit-shop-popup');
        },
        itemsLoaded(data){
            this.getFeedLikes(data);
        }
    },
    head() {
        return {
            title: get(this.meta, 'title', this.shop.name),
            meta: this.$options.filters.metaApiExtract({
                meta: this.meta
            }),
            link: [
                {
                    hid: 'i18n-can',
                    rel: 'canonical',
                    href: get(this.meta, 'canonical')
                }
            ]
        }
    }
};
</script>

<style lang="less">
.shop-detail-page {

    --image-size: rem(161);

    @{desktop} & {
        --image-size: rem(263);
    }

    &__header {
        min-height: rem(300);

        .section-card__footer {
            padding-top: rem(11);
        }
    }

    &__title {
        .page-padding();
    }

    &__title-name {
        font-size: rem(22);

        margin-bottom: rem(15);

        @{desktop} & {
            font-size: rem(28);
        }
    }

    &__title-caption {
        color: @color-gray;
        font-size: rem(16);
        line-height: rem(24);
        margin-bottom: rem(6);
        font-weight: 400;
        display: block;

        @{mobile} & {
            margin-bottom: rem(4);
        }
    }

    &__title-type {
        line-height: 1.55;
        text-align: left;
    }

    &__rightbar {
        .rightbar {
            &__button {
                margin-bottom: rem(12);
            }
        }
    }

    &__single-picture {
        display: flex;
        align-items: center;
        justify-content: center;

        margin-bottom: rem(20);

        height: rem(161);

        @{desktop} & {
            border: rem(1) solid @color-gray-white;
            border-radius: rem(5);

            margin-bottom: rem(38);
            padding: rem(40);

            height: rem(343);
        }

        img {
            object-fit: contain;

            height: var(--image-size);
            width: var(--image-size);
            max-height: 100%;
        }
    }

    &__social-block {
        display: flex;
        justify-content: flex-start;

        margin-top: rem(10);
    }

    &__social-button {
        &:first-child {
            margin-left: 0;
        }
    }

    &__manage-shop {
        padding-bottom: rem(12);

        &-counter {
            color: @color-primary;
            font-size: rem(15);
            font-weight: 500;

            transform: translateY(rem(-2));
        }
    }

    &__opinion-btn{
        position: relative;

        &:after{
            content: '';
            display: block;
            position: absolute;
            right: 0;
            width: rem(340);
            height: rem(40);
            top: 0;
        }
    }

    .info-table-row {
        --content-margin-top: rem(10);

        padding-top: rem(12);
        padding-bottom: rem(13);

        &__items_column {
            display: flex;
            flex-direction: column;
        }

        &_large-padding {
            padding-top: rem(16);
            padding-bottom: rem(16);
        }
    }

    &__review-button-subtext {
        color: @color-gray-light;
        font-size: rem(13);

        margin-top: rem(12);
        margin-bottom: 0;
    }

    &__desktop-buttons {
        display: flex;

        position: absolute;
        top: 0;
        right: 0;

        .rightbar__button {
            margin-left: rem(12);

            position: relative;
        }
    }

    &__link {
        display: flex;
        justify-content: space-between;
        color: @color-black;
        font-weight: normal;
        width: 100%;
        cursor: pointer;

        &:hover {
            color: @color-primary;
        }
    }

    &__remote-table-row {
        .info-table-row__title {
            width: 100%
        }
    }

    &__rating-and-reviews {
        @{desktop} & {
            display: flex;
            flex-direction: column;
            align-items: baseline;
        }

        .rating {
            --star-width: rem(21);
            --star-height: rem(18);

            @{desktop} & {
                --star-width: rem(27);
                --star-height: rem(22);
            }
        }
    }

    &__comments-and-reviews {
        @{desktop} & {
            margin-top: rem(12)
        }
    }

    &__header-reviews {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;

        @{desktop} & {
            margin-top: rem(32)
        }
    }

    &__review-button-wrapper {
        @{desktop} & {
            text-align: right;

            margin-top: rem(7);
        }
    }

    &__info-table {
        @{desktop} & {
            margin: rem(40) 0 rem(76);
        }
    }

    &__desktop-manage-shop {
        @{desktop} & {
            margin-top: rem(26);

            .page-block__content {
                padding-top: 0;
                padding-bottom: rem(12);
            }
        }

        .info-table-row__title{
            flex: 1;
        }
    }

    &__menu-more {
        position: absolute;
        top: rem(53);
        right: rem(-6);

        &[data-visible="true"] {
            visibility: visible;
            opacity: 1;
        }
    }

    &__menu-rate {
        position: absolute;
        right: 0;
        z-index: 10;

        @{desktop} & {
            top: rem(32);
        }

        &:before{
            content: '';
            display: block;
            position: absolute;
            left: 0;
            width: 100%;
            height: 40px;
            top: -40px;
        }

        &[data-visible="true"] {
            visibility: visible;
            opacity: 1;
        }
    }

    &__reviews-button-wrapper {
        text-align: right;
    }

    &__left-content-block {
        &_news {
            --desktop-header-padding-bottom: rem(10);

            margin-top: 0;
            margin-bottom: rem(-12);

            .articles-list__item {
                @{desktop} & {
                    margin-top: 0;
                    margin-bottom: rem(20);
                }
            }
        }
    }

    &__list-opinion {
        @{mobile} & {
            padding-top: rem(6);
            padding-bottom: rem(16);

            .range-slider + .range-slider {
                margin-top: rem(18);
            }
        }

        @{desktop} & {
            margin-top: rem(15);
        }
    }

    &__comments {
        .comments-and-reviews__sort-and-filter {
            padding-bottom: rem(15);
        }
    }

    &__comments-block {
        @{desktop} & {
            margin-top: rem(40);
        }
    }

    &__feed{
        .page-block{
            &__content{
                overflow: visible;
            }

            &__header{
                margin-bottom: rem(4);
                padding-top: 0;

                @{desktop} & {
                    padding: 0;
                    margin-bottom: rem(16);
                }
            }

            &__title{
                margin-bottom: 0;
            }
        }
    }

    &__main-wrapper{
        @{mobile} & {
            .page-block__content{
                overflow: visible;
            }
        }
    }
}

.dotted-link {
    cursor: pointer;
    border-bottom: rem(1) dashed @color-gray;
}
</style>
